import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CrmState } from '../../shared/models';

export const selectCrmState = createFeatureSelector<CrmState>('crm');

export const selectLastCreatedContactId = createSelector(
  selectCrmState,
  (state: CrmState | undefined) => state?.lastCreatedContactId ?? null
);

export const selectContacts = createSelector(
  selectCrmState,
  (state: CrmState | undefined) => state?.contacts ?? null
);

export const selectMatters = createSelector(
  selectCrmState,
  (state: CrmState | undefined) => state?.matters ?? null
);

export const selectCurrentContact = createSelector(
  selectCrmState,
  (state: CrmState | undefined) => state?.currentContact ?? null
);

export const selectCurrentMatter = createSelector(
  selectCrmState,
  (state: CrmState | undefined) => state?.currentMatter ?? null
);

export const selectMatterTimeline = createSelector(
  selectCrmState,
  (state: CrmState | undefined) => state?.timeline ?? null
);

export const selectBillingEvents = createSelector(
  selectCrmState,
  (state: CrmState | undefined) => state?.billingEvents ?? null
);

export const selectBillingTotal = createSelector(
  selectCrmState,
  (state: CrmState | undefined) => state?.billingTotal ?? null
);

export const selectNextTimelineCursor = createSelector(
  selectCrmState,
  (state: CrmState | undefined) => state?.nextTimelineCursor ?? null
);

export const selectLastCreatedMatterId = createSelector(
  selectCrmState,
  (state: CrmState | undefined) => state?.lastCreatedMatterId ?? null
);

export const selectCrmLoading = createSelector(
  selectCrmState,
  (state: CrmState | undefined) => !!state?.isLoading
);

export const selectCrmError = createSelector(
  selectCrmState,
  (state: CrmState | undefined) => state?.error ?? null
);

export const selectMatterDocuments = createSelector(
  selectCrmState,
  (state: CrmState | undefined) => state?.documents ?? null
);

export const selectDocumentUploadProgress = createSelector(
  selectCrmState,
  (state: CrmState | undefined) => state?.uploadProgress ?? null
);
